import React, { useState } from "react";
import MainHeaderPage from "../home/MainHeaderPage";
import Head from "../home/Head";

const HeadLayout = () => {
  // 1. Define the state here so both components can see it
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
<>
  <div className="sticky top-0 z-[999] bg-white">
    <MainHeaderPage />
    <Head
      mobileMenuOpen={isMenuOpen}
      setMobileMenuOpen={setIsMenuOpen}
    />
  </div>
</>
  );
};

export default HeadLayout;
